import { cloneDeep } from "lodash";
export class UndoHandler {
    constructor() {
        this.history = [];
        this.future = [];
    }
    add(item) {
        this.history.push(cloneDeep(item));
        this.future = [];
    }
    clear() {
        this.history = [];
        this.future = [];
    }
    get historyCount() {
        return this.history.length;
    }
    get canUndo() {
        return this.history.length > 0;
    }
    get futureCount() {
        return this.future.length;
    }
    get canRedo() {
        return this.future.length > 0;
    }
    undo(currentItem) {
        const previous = this.history.pop();
        if (previous === undefined)
            return currentItem;
        this.future.push(cloneDeep(currentItem));
        return previous;
    }
    redo(currentItem) {
        const next = this.future.pop();
        if (next === undefined)
            return currentItem;
        this.history.push(cloneDeep(currentItem));
        return next;
    }
}
